import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/index.css'
import apiConfig from '@/configs/api'
import baseConfig from '@/configs/base'
import resizer from '@/utils/eventResize'
import {localSet,localGet} from '@/utils/localCache'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'; // 引入样式
Vue.use(Antd);

Vue.component('icon',Icon)

// 分页组件
import Pagination from '@/components/Pagination'
Vue.component('Pagination', Pagination)

Vue.config.productionTip = false
Vue.prototype.apiConfig = apiConfig
Vue.prototype.baseConfig = baseConfig
Vue.prototype.resizer = resizer
Vue.prototype.localSet = localSet


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
